import Component from '../../js/_Component';
import BaseCarousel from '../BaseCarousel/_BaseCarousel';

const CNAME = 'c-block-testimonials-with-images';

export default class BlockTestimonialsWithImages extends Component {
	private images: HTMLElement[];

	private carousel: BaseCarousel;

	constructor(element: HTMLElement) {
		super(element);

		this.images = Array.from(this.element.querySelectorAll(`.${CNAME}--image`) as NodeListOf<HTMLElement>);

		const carouselElement = this.element.querySelector('.c-base-carousel') as HTMLElement;
		this.carousel = Component.getComponent(carouselElement);
		carouselElement.addEventListener('carouselitemchanged', () => this.updateDisplayedImage());

		this.element.querySelector(`.${CNAME}--carousel-dots`).appendChild(this.carousel.getDotsContainer());

		this.updateDisplayedImage();
	}

	updateDisplayedImage() {
		this.images.forEach((image) => {
			image.classList.remove('m-show');
		});
		this.images[this.carousel.getCurrentItem()].classList.add('m-show');
	}
}

Component.register(BlockTestimonialsWithImages, 'BlockTestimonialsWithImages');
